"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderInvite = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Icon_1 = require("../Icon");
// do not use empty string returned when white-labeling is not enabled, otherwise default color is not applied
var sanitizeColor = function (color) { return (color === "" ? undefined : color); };
exports.HeaderInvite = function (_a) {
    var onInviteItemClick = _a.onInviteItemClick, textColor = _a.textColor;
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement("div", { className: "gd-header-invite", onClick: onInviteItemClick },
        react_1.default.createElement(Icon_1.Icon.Invite, { color: sanitizeColor(textColor), className: "gd-header-invite-icon" }),
        react_1.default.createElement("span", { className: "gd-header-invite-text" }, intl.formatMessage({ id: "gs.header.invite" }))));
};
//# sourceMappingURL=HeaderInvite.js.map